import { render, staticRenderFns } from "./ServiceCalendar.vue?vue&type=template&id=c97475c8&scoped=true&"
import script from "./ServiceCalendar.vue?vue&type=script&lang=ts&"
export * from "./ServiceCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceCalendar.vue?vue&type=style&index=0&id=c97475c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97475c8",
  null
  
)

export default component.exports